import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {action, observable} from "mobx";
import { MyAccountStores } from "src/scenes/MyAccount/state/mobx";
import {ILoanPlanChangeRequest} from "../../../../../../shared/src/functions/membersApi/types/IPlanRequests";
import FirebaseMyAccountFunctionsService from "../../../../services/firebase/functions/FirebaseMyAccountFunctionsService";

const accountStore = MyAccountStores.accountUserStore;

export class ManageLoanStore extends ApiCallObservable {
    @observable public formInput: any = {};
    @observable public navigationController: any = {};

    @action
    public async submitLoanChangesRequest() {
        try {
            this.setSending();
            const loanUpdateRequest: ILoanPlanChangeRequest = {
                planId: accountStore.selectedPlan!.id,
                changeRequest: this.formInput.manageLoanPlan.selectedAction,
            };
            const response = await FirebaseMyAccountFunctionsService.updateLoanPlan(loanUpdateRequest);
            if (response.ok) {
                this.setSuccessfulResponse(response);
            } else {
                console.log(response);
                this.setError("Failed fetching summary");
            }
            return response;
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
            return false
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/ManageLoanStore.ts